import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { PKIUrls } from 'src/app/constants/pkiurls.constants';
import { CannotContainOnlySpaceValidator } from 'src/app/directives/cannot-contain-only-space-validator.directive';
import { MarkFormGroupTouchedAndDirty } from 'src/app/directives/mark-form-group-as-touched-dirty.function';

export const customUrlsAvatarMenuModalOptions: NgbModalOptions = {
  keyboard: false,
  centered: true,
  size: 'md',
  backdrop: 'static'
};


@Component({
  selector: 'app-custom-urls-avatarmenu-support-modal',
  templateUrl: './custom-urls-avatarmenu-support-modal.component.html'
})
export class CustomUrlsAvatarMenuSupportModal implements OnInit {
  @Output('updateOrganisationSettings') updateOrganisationSettings: EventEmitter<any> = new EventEmitter<any>();
  @Output('setSupportUrl') setSupportUrl: EventEmitter<any> = new EventEmitter();

  @Input('organisationSettings') set organisationSettings(val: any){
    this.supportUrl = (val.supportUrl == undefined || val.supportUrl == "" || val.supportUrl == "false") ? PKIUrls.CreateSupportTicket : val.supportUrl;
    this._organisationSettings = val;
  }
  get organisationSettings(): any {
    return this._organisationSettings;
  }
  private _organisationSettings!: any;
  supportUrl!: string;
  form!: UntypedFormGroup;
  supportUrlValue: FormControl;
  
  constructor(private formBuilder: UntypedFormBuilder, private activeModal: NgbActiveModal) { 
    this.supportUrlValue = new FormControl("", [Validators.required, CannotContainOnlySpaceValidator()]);
    this.form = this.formBuilder.group({
      supportUrl: this.supportUrlValue
    });
  }

  ngOnInit(): void {
    this.form.controls['supportUrl'].setValue(this.supportUrl);
  }

  save(){
    if (this.form.invalid) {
      MarkFormGroupTouchedAndDirty(this.form);
      return;
    }
    this.setSupportUrl.emit(this.form.controls['supportUrl'].value);
  }

  reset() {
    this.form.controls['supportUrl'].setValue(PKIUrls.CreateSupportTicket);
  }

  closeDialog() {
    this.activeModal.close(false);
  }
}
